import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import t from 'prop-types'

import {
  Button,
  Modal,
} from 'components/UI'
import AdminUserCreate from './AdminUserCreate'
import ManagerUserCreate from './ManagerUserCreate'

const Title = styled.h2`
  float: left;
  margin: 0 10px;
`
const AddButton =styled(Button)`
  float: left;
`

const UserCreate = ({ role, ...rest }) => {
  switch(role) {
    case 'Admin':
      return <AdminUserCreate {...rest} />
    case 'Manager':
      return <ManagerUserCreate {...rest} />
    default:
      return <div />
  }
}

class UserCreateButton extends Component {
  state = {
    isOpen: false,
  }

  close = () => {
    this.setState({
      isOpen: false,
    })
  }

  open = () => {
    this.setState({
      isOpen: true,
    })
  }

  render () {
    return (
      <div>
        <Title>Users</Title>
        <AddButton onClick={this.open}>Add</AddButton>
        { this.state.isOpen &&
          <Modal
            open={true}
            onBlur={this.close}
            width={800}
          >
            <UserCreate
              role={this.props.role}
              onSuccess={this.props.onSuccess}
              onCancel={this.close}
              organizationId={this.props.organizationId}
            />
          </Modal>
        }
      </div>
    )
  }
}

UserCreateButton.propTypes = {
  onSuccess: t.func.isRequired,
  organizationId: t.number,
}

const mapStateToProps = state => ({
  role: state.auth.role,
})

export default connect(mapStateToProps)(UserCreateButton)



// WEBPACK FOOTER //
// ./src/components/Profile/UserCreateButton.jsx